import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../../images/location_new/fold2/BgGame.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="example" data-text="London">
              <h2>Unmatched UK Game Developers at Your Service</h2>
            </div>
            <p>
              When it comes to hiring game developers, TekRevol is your gateway
              to unparalleled gaming experiences as UK game developers. We are
              committed to delivering unmatched gaming solutions, ensuring that
              your vision is not only realized but elevated to new heights. For
              that, our team stands out as a beacon of creativity and
              proficiency to transform your gaming aspirations into immersive
              realities.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
